import type { ReactNode } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowBack from '@mui/icons-material/ArrowBack';

type Props = { back: { to: string; label: string }; title: string; subtitle: string; children?: ReactNode };

/** The top of a form page: "← Back", the title, and the buttons (children) on the right */
export function FormHeader({ back, title, subtitle, children }: Props) {
  return (
    <Box>
      <Button component={RouterLink} to={back.to} startIcon={<ArrowBack />} size="small">
        {back.label}
      </Button>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        sx={{ justifyContent: 'space-between', alignItems: { sm: 'flex-start' } }}
      >
        <Box>
          <Typography variant="h4" component="h1">
            {title}
          </Typography>
          <Typography color="text.secondary">{subtitle}</Typography>
        </Box>
        <Stack direction="row" spacing={1}>
          {children}
        </Stack>
      </Stack>
    </Box>
  );
}
